import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { ConvertUserToAgentAccountAPI, ListAllUsersAPI, ListUsersAPI } from "./users.api";

export const usersKeys = {
  all: ["users"],
  lists: () => [...usersKeys.all, "list"],
  list: (params) => [...usersKeys.lists(), params],
};

export const useUsersListQuery = (params) =>
  useQuery({
    queryKey: usersKeys.list(params),
    queryFn: () => ListUsersAPI(params),
  });

export const useAllUsersExportMutation = () =>
  useMutation({
    mutationFn: ListAllUsersAPI,
  });

export const useConvertUserToAgentAccountMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ConvertUserToAgentAccountAPI,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: usersKeys.lists() });
      queryClient.invalidateQueries({ queryKey: ["agents", "list"] });
    },
  });
};
